import React, { useImperativeHandle } from 'react';
import { Formik } from 'formik';
import { InfiniteSelectField } from 'components/Molecules/FormFields/index';
import { Form } from 'antd';
import classes from './SaveAsNewTemplate.module.scss';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  templateName: Yup.mixed().required('Template name is required'),
});

export const SaveAsNewTemplate = React.forwardRef((props, ref) => {
  const formikRef = React.useRef();
  const { onSubmit, initialValues = { templateName: '' } } = props;

  useImperativeHandle(ref, () => ({
    getFormInstance: () => formikRef.current,
    submit: () => {
      formikRef.current.submitForm();
    },
    resetForm: () => {
      formikRef.current.resetForm();
    },
  }));

  const handleSubmit = (values) => {
    if (onSubmit) {
      onSubmit(values);
    }
  };

  return (
    <Formik
      initialValues={initialValues}
      enableReinitialize
      onSubmit={handleSubmit}
      validationSchema={validationSchema}>
      {(formikProps) => {
        formikRef.current = formikProps;
        return (
          <Form layout="vertical" className={classes.saveAsNewTemplate}>
            <InfiniteSelectField
              resource="quality-requirements/templates"
              label="Name"
              required
              name="templateName"
              labelKey="templateName"
              creatable
              showArrow
              onChange={({ field }, ...args) => {
                const [, option] = args;
                field.onChange({
                  target: {
                    name: field.name,
                    value: option,
                  },
                });
              }}
              onFilterParams={(filters) => {
                return {
                  ...filters,
                  keyword: filters.keywords,
                };
              }}
            />
          </Form>
        );
      }}
    </Formik>
  );
});
